// extracted by mini-css-extract-plugin
export var contactHolder = "contact-module--contactHolder--+H-eh";